import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import ArchiveList from "@/pages/archive/page";
import ArchiveDetail from "@/pages/archive/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/archive",
    element: <ArchiveList />,
  },
  {
    path: "/archive/:slug",
    element: <ArchiveDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;